import InfiniteScrollStore from '@/store/modules/InfiniteScrollStore'
import Timeline from '@/api/timeline'
import { AxiosRequestConfig } from 'axios'

export interface TimelineState {
  type: number
  savePhotoPoint: string
  saveVideoPoint: string
  buyPhotoPoint: string
  buyVideoPoint: string
  postPoint: string
  rejectedText: string
  rejectedEntry: TimelineItem
}

export interface TimelineItem {
  name: string
  user_id: string
  t_id: string
  image_url: string
  media_type?: string
  media_thumbnail?: string
  media_url?: string
  time: string
  comment: string
  iine_num: number
  iine: boolean
  is_premier?: boolean
  bought?: boolean
  fav: boolean
  own: boolean
  rejected?: boolean
  index: number
}

interface TimelnePost {
  formData: FormData
  config?: AxiosRequestConfig
}

interface TimelineRemove {
  id: string
  entryKey: string
}

const defaultState = Object.assign(
  {
    type: 0,
    savePhotoPoint: '',
    saveVideoPoint: '',
    buyPhotoPoint: '',
    buyVideoPoint: '',
    postPoint: '',
    rejectedText: '',
    rejectedEntry: null
  },
  InfiniteScrollStore.defaultState
)

const state: TimelineState = Object.assign({}, defaultState)

const mutations = Object.assign(
  {
    resetState(state: TimelineState) {
      const s = defaultState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    setType(state: TimelineState, type: number) {
      state.type = type
    },
    setSavePhotoPoint(state: TimelineState, pt: string) {
      state.savePhotoPoint = pt
    },
    setSaveVideoPoint(state: TimelineState, pt: string) {
      state.saveVideoPoint = pt
    },
    setBuyPhotoPoint(state: TimelineState, pt: string) {
      state.buyPhotoPoint = pt
    },
    setBuyVideoPoint(state: TimelineState, pt: string) {
      state.buyVideoPoint = pt
    },
    setPostPoint(state: TimelineState, pt: string) {
      state.postPoint = pt
    },
    setRejectedText(state: TimelineState, rejectedText: string) {
      state.rejectedText = rejectedText
    },
    setRejectedEntry(state: TimelineState, entry: TimelineItem) {
      state.rejectedEntry = entry
    }
  },
  InfiniteScrollStore.mutations
)

const actions = Object.assign(
  {
    toggleIine({ commit }, payload: { entry: any; index: number }): Promise<any> {
      return Timeline.toggleIine(payload.entry.t_id)
        .then(data => {
          if (data && !data.error) {
            commit('setEntry', {
              entry: Object.assign(payload.entry, {
                iine: data.iine,
                iine_num: data.iine_num
              }),
              index: payload.index
            })
          }
          return data
        })
        .catch(err => {
          throw err
        })
    },

    /**
     * 投稿
     */
    post({}, { formData, config }: TimelnePost): Promise<any> {
      return Timeline.post(formData, config).catch(err => {
        throw err
      })
    },

    /**
     * 削除リクエストと entries から該当の entry を削除
     */
    remove({ commit }, { id, entryKey }: TimelineRemove): Promise<any> {
      return Timeline.remove({
        page: 'remove',
        t_id: id
      })
        .then(data => {
          if (!data.error) {
            commit('removeEntry', entryKey)
          }
          return data
        })
        .catch(err => {
          throw err
        })
    }
  },
  InfiniteScrollStore.actions
)

const getters = Object.assign(
  {
    type: (state: TimelineState): number => state.type,
    savePhotoPoint: (state: TimelineState): string => state.savePhotoPoint,
    saveVideoPoint: (state: TimelineState): string => state.saveVideoPoint,
    buyPhotoPoint: (state: TimelineState): string => state.buyPhotoPoint,
    buyVideoPoint: (state: TimelineState): string => state.buyVideoPoint,
    postPoint: (state: TimelineState): string => state.postPoint,
    rejectedText: (state: TimelineState): string => state.rejectedText,
    rejectedEntry: (state: TimelineState): TimelineItem => state.rejectedEntry
  },
  InfiniteScrollStore.getters
)

export default {
  namespaced: true,
  defaultState,
  state,
  mutations,
  actions,
  getters
}
